module.exports = "/dist/images/pdf.png?8b04f89ca9acba18ab8d1fef70bf2631";